import { Tooltip } from "antd";
import CallDialTimer from "./timer";
import DialInputs from "./numbertyping";
import React, { useState } from "react";
import DiallpadToast from "./toastbottom";
import { useSelector } from "react-redux";
import DialPadNumber from "./dialpadnumber";
import { config } from '../../../base/constant';
import DialPadContactLists from "./contactlists";
import store from "../../../context/store/store";
import { UserDetails } from "../../../models/model";
import styles from "./scss/dialpadmain.module.scss";
import { calldetail, callMainPageInterface, initialCallStateModel, updatedCallStore } from "../../../models/callModel";
import callencryptSm from "../../../styles/images/callencryptSm.svg";
import { frameCallProfile, getCurrentCallDetail, toastInformation, toastMessageCallWindow } from "../../../base/callService/common";
import { callnow, initiateCall } from "../../../base/callService/callService";
import { incomingCallDetail } from "../../../base/callService/callsApiService";
import { callPlusIconAction, popoutStores } from "../../../base/callService/store_mining";
import _ from "lodash";

type CallDialPadMainState = {
  currentTimeState: boolean,
  isActive2: boolean,
  contactListshow: boolean,
  callInputBox: string,
  contactName: string,
  contactListUI: boolean
};

export default function CallDialPadMain() {
  const { contactReducer }: callMainPageInterface = useSelector((state: callMainPageInterface) => state);
  const [getCallDialPadMain, setCallDialPadMain] = useState<CallDialPadMainState>({
    currentTimeState: true,
    isActive2: false,
    contactListshow: false,
    callInputBox: '',
    contactName: '',
    contactListUI:false
  });

  const callState: initialCallStateModel = useSelector((state: initialCallStateModel) => state);

  const { updatedCallList,  showError }: updatedCallStore
    = useSelector((state: updatedCallStore) => state);
  let { leftSideWindow, rightSideWindow, isWindowSlide } = store.getState().updatedCallList;
  
  const mainCallWindow = () => {
    
    let currentCallList: calldetail[] = store.getState().updatedCallList.callDetails || [];
    let activeCallDetail: any = getCurrentCallDetail();
    let index: number = _.findIndex(currentCallList, { isCurrent: true });
    let alreadycurrencalllist: any = index > -1 && currentCallList && currentCallList[index]?.groupCallInfo?.GroupDetails;
    let alreadycurrentIndividualCalllist :any = index > -1 && currentCallList && currentCallList[index]?.groupCallInfo?.IndividualDetails;
    let userData:any = frameCallProfile(getCurrentCallDetail()||{});
    if (alreadycurrencalllist || alreadycurrentIndividualCalllist   ) { // Check if alreadycurrencalllist is not undefined or null
        let getCurrentCallList: any ={};
        let keysvale = Object.keys(alreadycurrencalllist);
        keysvale.forEach((data) => {
            getCurrentCallList = alreadycurrencalllist[data];
      
        });

        let getCurrentindividualCallList:any={};
        getCurrentindividualCallList = alreadycurrentIndividualCalllist;

        let arr: any = [];
        arr.push(getCallDialPadMain.callInputBox);
        let matchedCurrentList: any = arr.find((x: any) => !getCurrentCallList[x]);
        let matchedCurrentIndividualList :any =arr.find((x: any) =>  !getCurrentindividualCallList || !getCurrentindividualCallList[x]);
        
   
        if (matchedCurrentList !== undefined && matchedCurrentIndividualList !== undefined && userData.connectingStatus !=="Ringing" && getCallDialPadMain.callInputBox.toString() !== userData.ext.toString()) {
          
            if (getCallDialPadMain.callInputBox !== '') {
                let callCheck: any = callnow(getCallDialPadMain.callInputBox, "audio");
                if (callCheck.isCheck) {
                    toastMessageCallWindow(callCheck.error);
                    return true;
                }
                else {
                    initiateCall((getCallDialPadMain.callInputBox).toString(), 'audio');
                    setCallDialPadMain({
                        ...getCallDialPadMain, currentTimeState: true,
                        callInputBox: '', contactName: ''
                    });
                }
            }
            else {
                let { logs } = store.getState().callReducer || [];
                if (logs?.length > 0 && leftSideWindow === 'callList') {
                    let loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
                    let dialledNo: any = ((logs[0]?.calledNo === loggedUser?.ext?.toString()) ? logs[0]?.callingNo : logs[0]?.calledNo);
                    setCallDialPadMain({
                        ...getCallDialPadMain, currentTimeState: false,
                        callInputBox: (dialledNo).toString(), contactName: (logs[0]?.callerId) ? logs[0]?.callerId : dialledNo
                    });
                }
                else {
                    toastMessageCallWindow(config().ENTER_VALID_NUMBER);
                }
            }
        }
        else {
            toastInformation("You are already in call ");
        }
    } else {
      const {incomingCallWindow} = callState;
      const incomingInfo: any = incomingCallWindow.incomingCallDetail;
        console.log(incomingInfo.bound,"incomingInfoincomingInfo");

      if (getCallDialPadMain.callInputBox !== '') {
        
        let callCheck: any = callnow(getCallDialPadMain.callInputBox, "audio");
        if(incomingInfo.bound !=="IN"){
        if (callCheck.isCheck) {
            toastMessageCallWindow(callCheck.error);
            return true;
        }
        else {
            initiateCall((getCallDialPadMain.callInputBox).toString(), 'audio');
            setCallDialPadMain({
                ...getCallDialPadMain, currentTimeState: true,
                callInputBox: '', contactName: ''
            });
        }
      }
      else{
        toastInformation("You are already in call ");
      }
    }
    else {
        let { logs } = store.getState().callReducer || [];
        let index:any =null;
        for(let i=0;i<logs.length;i++)
        {
          if(!logs[i].groupId)
          {
            index=i;
            break;
          }
        }
        if((logs?.length > 0 && leftSideWindow === 'callList') || !logs[0]?.groupId)
        // if (logs?.length > 0 && leftSideWindow === 'callList') 
        {
            let loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
            let dialledNo: any = ((logs[index]?.calledNo === loggedUser?.ext?.toString()) ? logs[index]?.callingNo : logs[index]?.calledNo);
            setCallDialPadMain({
                ...getCallDialPadMain, currentTimeState: false,
                callInputBox: (dialledNo)?.toString(), contactName: (logs[index]?.callerId) ? logs[index]?.callerId : dialledNo
            });
        }
        else {
            toastMessageCallWindow(config().ENTER_VALID_NUMBER);
        }
    }
    }
};

  const dialPadKeyevent = (key: string) => {
    let inputs: string = getCallDialPadMain.callInputBox + key;
    let currentUserData: any = incomingCallDetail(inputs);
    setCallDialPadMain({
      ...getCallDialPadMain, currentTimeState: false,
      callInputBox: inputs, contactName: currentUserData['caller_id']
    });
  };

  const dialPadKeyBoardevent = (keyValue: string) => {
    let timerStatus: boolean = (keyValue === '' ? true : false);
    let currentUserData: any =  incomingCallDetail(keyValue);
     keyValue=keyValue.replace(/[^0-9*#+]/g, '');
    setCallDialPadMain({
      ...getCallDialPadMain, currentTimeState: timerStatus,
      callInputBox: keyValue, contactName: currentUserData['caller_id']
    });
  };

  const dialPadBackSpace = () => {
    let textBoxValue: string = (getCallDialPadMain?.callInputBox)?.toString();
    if (textBoxValue.length !== 0) {
      textBoxValue = textBoxValue?.substring(0, textBoxValue?.length - 1);
      let timerStatus: boolean = (textBoxValue === '' ? true : false);
      let currentUserData: any = incomingCallDetail(textBoxValue);

      setCallDialPadMain({
        ...getCallDialPadMain, currentTimeState: timerStatus,
        callInputBox: textBoxValue, contactName: currentUserData['caller_id']
      });
    }
  };

  const contactListShow = () => {
    setCallDialPadMain({ ...getCallDialPadMain, contactListshow: true });
  };

  const contactListHide = () => {
    setCallDialPadMain({ ...getCallDialPadMain, contactListshow: false });
  };

  const selectedContactList = (ext: string, selectedContactName: string) => {
    setCallDialPadMain({
      ...getCallDialPadMain, contactListshow: false,
      currentTimeState: false, callInputBox: (ext).toString(), contactName: selectedContactName
    });
  };

  const dailpadPopout = () => {
    callPlusIconAction(true, 'dialPad');
    popoutStores();
  }

  /*const addCallContactNodata = (data: any) => {
    setCallDialPadMain({
      ...getCallDialPadMain, contactListUI:!getCallDialPadMain.contactListUI
    });
  };*/
  let isdialpadWin: Boolean = (updatedCallList.callDetails && updatedCallList.callDetails.length > 0) ?( (updatedCallList.rightSideWindow==='dialPad')?false:true) : true;
  return (
    <>
      <div className={styles.dialpadmain}>
        {/* {isdialpadWin &&
          <div className={styles.newcall}>
            <h3> </h3>
          </div>
        } */}
        <div className={updatedCallList.isCallFullScreen ? `${styles.dialpadsections} ${styles.dialPadRemoveSpace}`
          : `${styles.dialpadsections}`}>

         {(!updatedCallList.isCallActive&&!updatedCallList.minimizedWindow)&&<Tooltip placement="topRight" title="Pop Out">
            <span className={`${"icon_popin"} ${styles.popout}`} onClick={dailpadPopout}></span>
          </Tooltip>}

          <div className={`${getCallDialPadMain.currentTimeState ? `${styles.midsections} animate__animated animate__fadeIn animate__fast` : `${styles.midsections} ${styles.midsectionsnew}`
            } ${(getCallDialPadMain.contactListshow || getCallDialPadMain.contactListUI)
              && `${styles.contactListSec}`}`}>

            {isdialpadWin&&
            <div className={styles.callTimerSection}><CallDialTimer/></div>
            }
            <div className={!isdialpadWin ? `${styles.maindialpads} ${styles.maindialpadshide}` :
              getCallDialPadMain.contactListshow ? styles.hideclass : `${styles.maindialpads}`}>
              {!getCallDialPadMain.currentTimeState &&
                <div className={`${styles.hideclass} ${styles.showclass}`}>
                  <DialInputs keyVal={getCallDialPadMain.callInputBox} callerName={getCallDialPadMain.contactName}
                    keyBoardEvent={dialPadKeyBoardevent} keyBoardBackSpace={dialPadBackSpace}></DialInputs>
                </div>
              }
              <DialPadNumber mainCallWindow={mainCallWindow} keyPressEventProps={dialPadKeyevent}
                ContactList={contactListShow} ></DialPadNumber>
            </div>

            {getCallDialPadMain.contactListshow && <div className={`${styles.maindialpadscontacts}`}>
              <DialPadContactLists contactBackEvent={contactListHide}
                selectedContact={selectedContactList} transferType={'Dialpad'}></DialPadContactLists>
            </div>}
          </div >
        </div >
        { (rightSideWindow === "dialpad" && isWindowSlide) && <div className={styles.encryptedBox}>
          <span className={styles.encryptedIcon}>
            <img src={callencryptSm} alt="" />
          </span>
          <span className={`${styles.encryptedText} ${styles.bigscreens}`}>
          Calls are end-to-end encrypted. No one outside of this call, not even Worktual, can hear or listen to them.
          </span>
          <span className={`${styles.encryptedText} ${styles.smallscreens}`}>
          Calls are end-to-end encrypted.          </span>
        </div>}
      </div>
      { showError.isToast && <DiallpadToast showMsg={showError.message}></DiallpadToast> }
    </>
  );
};
